// context/AuthContext.js
import React, { createContext, useEffect, useState } from 'react';
import { fetchUserInfo } from '../services/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUserRole = async () => {
    const res = await fetchUserInfo();
    if (res.success) {
      setRole(res.data.role);
    } else {
      console.error(res.message);
      setRole(null);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadUserRole();
  }, []);

  return (
    <AuthContext.Provider value={{ role, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
